import  "../../assets/css/community-section.css";
import { useState, useContext, useEffect, useRef } from "react";
import Expando from "../Expando/Expando";
import Section from "../Section/Section";
import StateContext from "../../state/stateContext";
import useQueryCommunityNews from "../Hooks/useQueryCommunityNews";
import useQueryChildData from "../Hooks/useQueryChildData";

export function CommunitySection(props) {
  const { children, classList="", collapsedText } = props;
  const context = useContext(StateContext);
  const sectionRef = useRef();
  const [imageStatus, setImageStatus] = useState("pending");
  const [imageUrl, setImageUrl] = useState("");
  const queryChildData = useQueryChildData(context);
  const queryCommunityNews = useQueryCommunityNews(context);

  useEffect(() => {
     if (queryChildData.isSuccess && imageStatus === "pending") {
        const { projectIdentifier } = queryChildData?.data || {};
        setImageStatus("loading");
        queryCommunityNews.request(projectIdentifier);
     } else if (queryCommunityNews.isError) {
        const fallbackSrc = "https://wvusstatic.com/illustrations/map-pin-globe.svg";
        setImageUrl(fallbackSrc);
        setImageStatus("error");
     }
  }, [queryChildData, imageUrl, queryCommunityNews]);

  useEffect(() => {
     if (queryCommunityNews.isSuccess && imageStatus === "loading") {
        const { latitude:lat, longitude:lon } = queryCommunityNews.parseDataFields([
           "latitude",
           "longitude"
        ], queryCommunityNews.data);

        const url = queryCommunityNews.getMapImage({
           lat, lon, width: "100", height: "133"
        });

        setImageUrl(url);
        setImageStatus("success");
     }
  }, [queryCommunityNews, imageStatus, setImageUrl, setImageStatus]);

  const isLoading = (queryCommunityNews.isWaiting || ["pending", "loading"].includes(imageStatus));
  const thumbnailUrl = imageUrl;

  return (
    <Section isLoading={isLoading} sectionRef={sectionRef} classList={`three-column__right-rail ${classList} section-container section-container__community`}>
      <Expando thumbnailUrl={thumbnailUrl} collapsedText={collapsedText} name={"My Community"} sectionRef={sectionRef}>
        <h2 className="epsilon">My Community</h2>         
        { children }
      </Expando>
    </Section>
  );
}

export default CommunitySection;